export default () => ({
  configs: null,
  sealConfigs: null
})
